import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=6054d7b8&scoped=true"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"
import style0 from "./custom.vue?vue&type=style&index=0&id=6054d7b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054d7b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6054d7b8')) {
      api.createRecord('6054d7b8', component.options)
    } else {
      api.reload('6054d7b8', component.options)
    }
    module.hot.accept("./custom.vue?vue&type=template&id=6054d7b8&scoped=true", function () {
      api.rerender('6054d7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customManage/custom.vue"
export default component.exports